export default "__VITE_ASSET__DXZe91Ie__"